import React from "react";

const Active24Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
  >
    <g clip-path="url(#clip0_248_87041)">
      <path
        d="M4.42359 3.75758C6.09102 2.09016 8.30793 1.17188 10.666 1.17188C12.4693 1.17188 14.2127 1.72043 15.6789 2.73309L14.547 2.84918L14.6666 4.01492L17.7135 3.70242L17.401 0.655547L16.2352 0.775117L16.3365 1.76305C14.6772 0.619414 12.7054 0 10.666 0C7.99492 0 5.48371 1.0402 3.59496 2.92895C1.70621 4.8177 0.666016 7.32891 0.666016 10C0.666016 11.9997 1.25445 13.9299 2.3677 15.5818L3.33949 14.927C3.32602 14.9069 3.31293 14.8867 3.29961 14.8666C2.34328 13.4222 1.83789 11.7413 1.83789 10C1.83789 7.64195 2.75617 5.425 4.42359 3.75758Z"
        fill="#191919"
      />
      <path
        d="M18.965 4.41797L17.9931 5.07285C18.0066 5.09285 18.0197 5.11312 18.033 5.1332C18.9893 6.57758 19.4947 8.25855 19.4947 9.9998C19.4947 12.3579 18.5764 14.5748 16.909 16.2422C15.2416 17.9096 13.0247 18.8279 10.6666 18.8279C8.86332 18.8279 7.11988 18.2794 5.65367 17.2667L6.78559 17.1506L6.66602 15.9849L3.61914 16.2974L3.93164 19.3443L5.09742 19.2247L4.99609 18.2368C6.65543 19.3804 8.62727 19.9998 10.6666 19.9998C13.3377 19.9998 15.8489 18.9596 17.7377 17.0709C19.6264 15.1821 20.6666 12.6709 20.6666 9.9998C20.6666 8.00012 20.0782 6.06992 18.965 4.41797Z"
        fill="#191919"
      />
      <path
        d="M5.54898 11.2299L6.30758 10.5287C6.88227 10 6.99148 9.64369 6.99148 9.25291C6.99148 8.5058 6.35355 8.02881 5.42832 8.02881C4.63523 8.02881 4.06629 8.36213 3.76172 8.86787L4.60652 9.33912C4.76742 9.08053 5.0318 8.94834 5.32488 8.94834C5.66969 8.94834 5.84211 9.1035 5.84211 9.36213C5.84211 9.52881 5.79613 9.71272 5.4743 10.0115L3.96859 11.4196V12.1322H7.10066V11.2299L5.54898 11.2299Z"
        fill="#191919"
      />
      <path
        d="M10.7141 11.3621H11.3117V10.4599H10.7141V9.77602H9.63938V10.4599H8.82332L10.4612 8.10938H9.28305L7.47852 10.6208V11.3621H9.60488V12.1322H10.7141V11.3621Z"
        fill="#191919"
      />
      <path
        d="M12.3462 12.7066L14.2427 7.29297H13.2715L11.375 12.7066H12.3462Z"
        fill="#191919"
      />
      <path
        d="M15.2095 9.6323V9.01164H16.267L14.9107 12.1322H16.152L17.5715 8.82199V8.10938H14.2383V9.6323H15.2095Z"
        fill="#191919"
      />
    </g>
    <defs>
      <clipPath id="clip0_248_87041">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.666016)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default Active24Icon;
